import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { IVehicleList } from "../../../Pages/Vehicle/Ivehicle";
import { IPricingList } from '../../../Pages/Pricing/IPricing';

export const AddPricingSlicer = createSlice({
  name: 'AddPricing',
  initialState: {
    data: {},
    isLoading: false,
  } as IReduxState<IPricingList>,
  reducers: {
    addPricing: (state, _) => {
      state.isLoading = true;
    },
    successAddPricing: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    failureAddPricing: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    clearAddPricingState: (state) => {
      state.data = {};
    },
  },
});

export const {
  addPricing,
  successAddPricing,
  failureAddPricing,
  clearAddPricingState,
} = AddPricingSlicer.actions;

export default AddPricingSlicer.reducer;
